/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_KYC_DOCS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateKycMethods extends IPluginMethodMap {
  getUpdateKyc(args: any): Promise<any>;
}

export interface UpdateKycProps {
  addressProofType?: string;
  idProofType?: string;
  addressProof?: any;
  idProof?: any;
}

export class UpdateKycService implements IAgentPlugin {
  readonly methods: IUpdateKycMethods;

  constructor() {
    this.methods = {
      getUpdateKyc: this.getUpdateKyc.bind(this),
    };
  }

  async getUpdateKyc(args: UpdateKycProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_KYC_DOCS,
          variables: {
            input: {
              documents: this.getDocuments(args),
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.editKYCDoc) {
          return {
            data: res?.data?.editKYCDoc?.message,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }

  private getDocuments(args: any) {
    let _docs = [];
    if (args?.idProofType) {
      _docs.push({
        doc: args?.idProof[0]?.base64,
        type: "ID_PROOF",
        name: args?.idProofType,
        status: "SUBMITTED",
      });
    }
    if (args?.addressProofType) {
      _docs.push({
        doc: args?.addressProof[0]?.base64,
        type: "ADDRESS_PROOF",
        name: args?.addressProofType,
        status: "SUBMITTED",
      });
    }
    return _docs;
  }
}
